import {IntermediatePart} from "../../intermediatePart";
import store from "../../../../../store";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class Stovetop extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'stovetop';
    this.partName = 'Stovetop';
    this.translateId = "visualizer.kitchen.center_island.center_island_stovetop";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Stovetop());
  }

  handleClick(ignoreLocked = false, clickFrom = "") {
    const {isEncore} = store.getState().fabricatorState;
    if (isEncore) {
      const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);
      if (ignoreLocked || !featureIsLocked) {
        const applianceParent = this.getParent().getParent();
        if (applianceParent.layout.type === 6) {
          if (applianceParent.microwave && !applianceParent.microwave.disabled) {
            applianceParent.microwave.disabled = true;
          }
          if (applianceParent.hood && applianceParent.hood.disabled) {
            applianceParent.hood.disabled = false;
          }
        }
      }
    }
    return super.handleClick(ignoreLocked, clickFrom);
  }

  disabledClick() {
    const applianceParent = this.getParent();
  //   if (!this.disabled) {
  //     // centerIslandParent.cabinet.disabled = false;
  //     // centerIslandParent.cabinet.disabledClick();
  //   } else {
  //     if (applianceParent.hood) {
  //       applianceParent.hood.disabled = this.disabled;
  //     }
  //   }
    if ((applianceParent.layout.type === 6) && !this.disabled && applianceParent.range
      && !applianceParent.range.disabled) {
      applianceParent.range.disabled = true;
    }
  }

}
